/**
 * The Meta counterpart to `grantUETConsent` — see it for the Cookiebot
 * hydration race this covers. Must be called from an effect rather than the
 * pixel's `onReady`: next/script fires that before the inline script is
 * appended, so `fbq` is still undefined and the grant silently no-ops.
 */
export const grantFBConsent = () => {
  if (!window.Cookiebot?.consent?.marketing) {
    return;
  }

  window.fbq?.('consent', 'grant');
};
